import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-admin-permission-help',
  template: `
    <div>
      <span><b>{{'USER_PERMISSIONS.ADMIN.INTRODUCTION' | translate}}:</b></span>
      <ul class="m-0">
        <li [innerHtml]="'USER_PERMISSIONS.ADMIN.CAN_READ_ALL' | translate"></li>
        <li [innerHtml]="'USER_PERMISSIONS.ADMIN.CAN_EDIT_ORGANIZATION_SETTINGS' | translate"></li>
        <li [innerHtml]="'USER_PERMISSIONS.ADMIN.CAN_READ_EDIT_ADMINISTRATION_CONFIGURATION' | translate"></li>
      </ul>
    </div>
  `
})
export class AdminPermissionHelpComponent {
  constructor(public translate: TranslateService) {
  }
}
